import React, { Component } from 'react'
import { withStyles } from '@material-ui/core/styles';
import FullScreenDialog from './FullScreenDialog'
import Avatar from '@material-ui/core/Avatar';
import WarningIcon from '@material-ui/icons/Warning'
import InfoIcon from '@material-ui/icons/Info'
import ErrorIcon from '@material-ui/icons/Error'
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import ListItemText from '@material-ui/core/ListItemText';
import Button from '@material-ui/core/Button'


const styles = (theme) => {
    return ({
        card: {
            marginBottom: '20px'
        },
        cardTitle: {
            marginLeft: '15px',
            marginTop: '15px',
        },
    })
};

class ValidationProblemsDialog extends Component {
    // constructor(props) {
    //     super(props);
    //     this.state = {
            
    //     }
    // }

    render() {
        const { classes } = this.props;
        let has_danger_messages = this.props.problems.reduce((x, y) => x || y.type === 'danger', false)

        const extra_buttons = []

        if(!has_danger_messages){
            extra_buttons.push(
                <Button onClick={this.props.handleContinue} color="primary" variant="contained">Continue</Button>
            )
        }

        return (
            <FullScreenDialog
                open={true}
                title={'Problems'}
                bodyPadding="20px"
                handleClose={this.props.handleClose}
                handleSave={this.handleSave}
                extraButtons={extra_buttons}
                hide_save_button={true}
            >
                <div style={{minWidth: 300}}>
                    {
                        this.props.problems.length ?
                            <React.Fragment>
                                <List className={classes.root}>
                                    {this.props.problems.map(element => {
                                        let avatar = ''

                                        switch (element.type) {
                                            case 'warning':
                                                avatar = <WarningIcon htmlColor='#ffeb3b'/>
                                                break;
                                            case 'danger':
                                                avatar = <ErrorIcon htmlColor='#f44336'/>
                                                break;
                                            default:
                                                avatar = <InfoIcon htmlColor='#3f51b5'/>
                                        }
                                        return (
                                            <ListItem className={classes.line} key={'item-' + element['id']}>
                                                <ListItemAvatar>
                                                    <Avatar>
                                                        {avatar}
                                                    </Avatar>
                                                </ListItemAvatar>
                                                <ListItemText
                                                    primary={
                                                        element.description
                                                    }
                                                />
                                            </ListItem>
                                        )
                                    })}
                                </List>
                            </React.Fragment>
                            :
                            <div style={{textAlign: 'center'}}>No pending syncronization tasks</div>
                    }
                </div>

            </FullScreenDialog>
        )
    }
}

export default withStyles(styles)(ValidationProblemsDialog);